if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      console.log("edeeee");

      
    //    document.querySelectorAll(".collection-color-block .color-variant-item").forEach(function(item) {
    //     item.addEventListener("click", function() {
    //         // Remove 'active' class from all color variants within the same block
    //         const parentBlock = this.closest(".collection-color-block");
    //         parentBlock.querySelectorAll(".color-variant-item").forEach(function(variant) {
    //             variant.classList.remove("active");
    //         });

    //         // Add 'active' class to the clicked item
    //         this.classList.add("active");

    //         // Get image sources
    //         const firstImg = this.querySelector(".first-img")?.getAttribute("src") || "";
    //         console.log(firstImg);
    //         const secImg = this.querySelector(".sec-img")?.getAttribute("src") || "";
    //         console.log(secImg);

    //         // Update product card images
    //         const productCard = this.closest(".product-card");
    //         if (productCard) {
    //             const mediaImages = productCard.querySelectorAll(".product-card__media img");
    //             if (mediaImages.length >= 2) {
    //                 mediaImages[0].setAttribute("src", firstImg);
    //                 mediaImages[0].setAttribute("srcset", firstImg);
    //                 mediaImages[1].setAttribute("src", secImg);
    //                 mediaImages[1].setAttribute("srcset", secImg);
    //             }
    //         }


    //       const id = this.getAttribute("id");
    //      console.log(id);
        
    //       if (productCard) {
    //           const productLink = productCard.querySelector(".product-card__actions .product-card__link");
    //           if (productLink) {
    //               productLink.setAttribute("href", id);
    //           }
    //       }

    //       var price = this.getAttribute("price");
    //       console.log(price);
    //       var priceElement = productCard.querySelector(".product-card__content .product-card__price .price__regular span:last-child");
    //       priceElement.textContent = price;
          
    //     });
    // });
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
      console.log("ss");
setTimeout(function(){
       document.querySelectorAll(".collection-color-block .color-variant-item").forEach(function(item) {
        item.addEventListener("click", function() {
          
            // Remove 'active' class from all color variants within the same block
            const parentBlock = this.closest(".collection-color-block");
            parentBlock.querySelectorAll(".color-variant-item").forEach(function(variant) {
                variant.classList.remove("active");
            });

            // Add 'active' class to the clicked item
            this.classList.add("active");

            // Get image sources
            const firstImg = this.querySelector(".first-img")?.getAttribute("src") || "";
            console.log(firstImg);
            const secImg = this.querySelector(".sec-img")?.getAttribute("src") || "";
            console.log(secImg);

            // Update product card images
            const productCard = this.closest(".product-card");
            if (productCard) {
                const mediaImages = productCard.querySelectorAll(".product-card__media img");
                if (mediaImages.length >= 2) {
                    mediaImages[0].setAttribute("src", firstImg);
                    mediaImages[0].setAttribute("srcset", firstImg);
                    mediaImages[1].setAttribute("src", secImg);
                    mediaImages[1].setAttribute("srcset", secImg);
                }
            }


          const id = this.getAttribute("id");
         console.log(id);
        
          if (productCard) {
              const productLink = productCard.querySelector(".product-card__actions .product-card__link");
              if (productLink) {
                  productLink.setAttribute("href", id);
              }
          }

          var price = this.getAttribute("price");
          console.log(price);
          var priceElement = productCard.querySelector(".product-card__content .product-card__price .price__regular span:last-child");
          priceElement.textContent = price;
          
        
        });  
    });
  }, 1000);
      
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
